import Messages from "./messages";

const Validations = {
  validateEmail: (value: any) => {
    let error;
    const validEmail = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!value) {
      error = Messages.TENANT.ERROR.EMAIL.EMPTY;
    } else if (!validEmail.test(value)) {
      error = Messages.TENANT.ERROR.EMAIL.INVALID;
    }

    return error;
  },
  validateRegisterForm: (form: any) => {
    const errors: any = {};
    const validEmail = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (!form.email) {
      errors.email = Messages.TENANT.ERROR.EMAIL.EMPTY;
    } else if (!validEmail.test(form.email)) {
      errors.email = Messages.TENANT.ERROR.EMAIL.INVALID;
    }
    // if (!form.fname) {
    //   errors.fname = Messages.TENANT.ERROR.FIRST_NAME.EMPTY;
    // } else if (!regex.test(form.fname)) {
    //   errors.fname = Messages.TENANT.ERROR.FIRST_NAME.INVALID;
    // }
    // if (!form.lname) {
    //   errors.lname = Messages.TENANT.ERROR.LAST_NAME.EMPTY;
    // } else if (!regex.test(form.lname)) {
    //   errors.lname = Messages.TENANT.ERROR.LAST_NAME.INVALID;
    // }
    return errors
  },
  validateLoginForm: (form: any) => {
    const errors: any = {};
    const validEmail = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (!form.email) {
      errors.email = Messages.TENANT.ERROR.EMAIL.EMPTY;
    } else if (!validEmail.test(form.email)) {
      errors.email = Messages.TENANT.ERROR.EMAIL.INVALID;
    }
    if (!form.password) {
      errors.password = Messages.SIGNUP.ERROR.PASSWORD.EMPTY;
    }
    return errors
  },
  validateDepartmentForm: (form: any) => {
    const errors: any = {};
    if (!form.department_alias) {
      errors.department_alias = Messages.DEPARTMENT.ERROR.DEPARTMENT_ALIAS.EMPTY;
    }
    if (!form.department_name) {
      errors.department_name = Messages.DEPARTMENT.ERROR.DEPARTMENT_NAME.EMPTY;
    }
    return errors
  },
  validateForm: (form: any) => {
    const errors: any = {};

    const UpperCase = "[A-Z]";

    const LowerCase = "[a-z]";

    const Numbers = "[0-9 s .!@@#$%^&*|]";
    if (!form.newPassword) {
      errors.newPassword = Messages.SIGNUP.ERROR.PASSWORD.EMPTY;
    } else if (form.newPassword.length < 7) {
      errors.newPassword = Messages.SIGNUP.ERROR.PASSWORD.INVALID;
    } else if (!new RegExp(UpperCase).test(form.newPassword)) {
      errors.newPassword = Messages.SIGNUP.ERROR.PASSWORD.INVALID;
    } else if (!new RegExp(LowerCase).test(form.newPassword)) {
      errors.newPassword = Messages.SIGNUP.ERROR.PASSWORD.INVALID;
    } else if (!new RegExp(Numbers).test(form.newPassword)) {
      errors.newPassword = Messages.SIGNUP.ERROR.PASSWORD.INVALID;
    } else if (/[`~,.<>;':"/[\]|{}()=_+-]/.test(form.newPassword)) {
      errors.newPassword = Messages.SIGNUP.ERROR.PASSWORD.INVALID;
    }
    if (!form.newPasswordAgain) {
      errors.newPasswordAgain = Messages.SIGNUP.ERROR.CPASSWORD.EMPTY;
    } else if (form.newPassword !== form.newPasswordAgain) {
      errors.newPasswordAgain = Messages.SIGNUP.ERROR.CPASSWORD.INVALID;
    }

    return errors;
  },
  validateFormProfile: (form: any) => {
    const errors: any = {};

    const UpperCase = "[A-Z]";

    const LowerCase = "[a-z]";

    const Numbers = "[0-9 s .!@@#$%^&*|]";
    if (!form.CurrentPass) {
      errors.CurrentPass = Messages.SIGNUP.ERROR.PASSWORD.EMPTY;
    } else if (form.CurrentPass.length < 7) {
      errors.CurrentPass = Messages.SIGNUP.ERROR.PASSWORD.INVALID;
    } else if (!new RegExp(UpperCase).test(form.CurrentPass)) {
      errors.CurrentPass = Messages.SIGNUP.ERROR.PASSWORD.INVALID;
    } else if (!new RegExp(LowerCase).test(form.CurrentPass)) {
      errors.CurrentPass = Messages.SIGNUP.ERROR.PASSWORD.INVALID;
    } else if (!new RegExp(Numbers).test(form.CurrentPass)) {
      errors.CurrentPass = Messages.SIGNUP.ERROR.PASSWORD.INVALID;
    } else if (/[`~,.<>;':"/[\]|{}()=_+-]/.test(form.CurrentPass)) {
      errors.CurrentPass = Messages.SIGNUP.ERROR.PASSWORD.INVALID;
    }

    if (!form.NewPass) {
      errors.NewPass = Messages.SIGNUP.ERROR.PASSWORD.EMPTY;
    } else if (form.NewPass.length < 7) {
      errors.NewPass = Messages.SIGNUP.ERROR.PASSWORD.INVALID;
    } else if (!new RegExp(UpperCase).test(form.NewPass)) {
      errors.NewPass = Messages.SIGNUP.ERROR.PASSWORD.INVALID;
    } else if (!new RegExp(LowerCase).test(form.NewPass)) {
      errors.NewPass = Messages.SIGNUP.ERROR.PASSWORD.INVALID;
    } else if (!new RegExp(Numbers).test(form.NewPass)) {
      errors.NewPass = Messages.SIGNUP.ERROR.PASSWORD.INVALID;
    } else if (/[`~,.<>;':"/[\]|{}()=_+-]/.test(form.NewPass)) {
      errors.NewPass = Messages.SIGNUP.ERROR.PASSWORD.INVALID;
    }

    return errors;
  },
  validateUserForm: (form:any) => {
    const errors: any = {};
    const validEmail = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    // const regex = /^[a-zA-Z]+$/
    const regex = /^[-\sa-zA-Z]+$/

    if (!form.username) {
      errors.username = Messages.TENANT.ERROR.EMAIL.EMPTY;
    } else if (!validEmail.test(form.username)) {
      errors.username = Messages.TENANT.ERROR.EMAIL.INVALID;
    }
    if (!form.firstname) {
      errors.firstname = Messages.TENANT.ERROR.FIRST_NAME.EMPTY;
    } else if (!regex.test(form.firstname)) {
      errors.firstname = Messages.TENANT.ERROR.FIRST_NAME.INVALID;
    }
    if (!form.lastname) {
      errors.lastname = Messages.TENANT.ERROR.LAST_NAME.EMPTY;
    } else if (!regex.test(form.lastname)) {
      errors.lastname = Messages.TENANT.ERROR.LAST_NAME.INVALID;
    }
    return errors
  },
  validateEditUserForm: (form:any) => {
    const errors: any = {};
    // const regex = /^[a-zA-Z]+$/
    const regex = /^[-\sa-zA-Z]+$/
    
    if (!form.firstname) {
      errors.firstname = Messages.TENANT.ERROR.FIRST_NAME.EMPTY;
    } else if (!regex.test(form.firstname)) {
      errors.firstname = Messages.TENANT.ERROR.FIRST_NAME.INVALID;
    }
    if (!form.lastname) {
      errors.lastname = Messages.TENANT.ERROR.LAST_NAME.EMPTY;
    } else if (!regex.test(form.lastname)) {
      errors.lastname = Messages.TENANT.ERROR.LAST_NAME.INVALID;
    }
    return errors
  },
  validateResetPassword: (form: any) => {

    const errors: any = {};

    const UpperCase = "[A-Z]";

    const LowerCase = "[a-z]";

    const Numbers = "[0-9 s .!@@#$%^&*|]";

    if (!form.password) {
      errors.password = Messages.SIGNUP.ERROR.PASSWORD.EMPTY;
    } else if (form.password.length < 7) {
      errors.password = Messages.SIGNUP.ERROR.PASSWORD.INVALID;
    } else if (!new RegExp(UpperCase).test(form.password)) {
      errors.password = Messages.SIGNUP.ERROR.PASSWORD.INVALID;
    } else if (!new RegExp(LowerCase).test(form.password)) {
      errors.password = Messages.SIGNUP.ERROR.PASSWORD.INVALID;
    } else if (!new RegExp(Numbers).test(form.password)) {
      errors.password = Messages.SIGNUP.ERROR.PASSWORD.INVALID;
    } else if (/[`~,.<>;':"/[\]|{}()=_+-]/.test(form.password)) {
      errors.password = Messages.SIGNUP.ERROR.PASSWORD.INVALID;
    }

    return errors;
  },
  validateForgotPasswordForm: (form: any) => {
    const errors: any = {};
    const validEmail = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (!form.email) {
      errors.email = Messages.TENANT.ERROR.EMAIL.EMPTY;
    } else if (!validEmail.test(form.email)) {
      errors.email = Messages.TENANT.ERROR.EMAIL.INVALID;
    }

    return errors
  },
  validateResetPasswordForm: (form: any) => {
    const errors: any = {};

    const UpperCase = "[A-Z]";

    const LowerCase = "[a-z]";

    const Numbers = "[0-9 s .!@@#$%^&*|]";
    if (!form.password) {
      errors.password = Messages.SIGNUP.ERROR.PASSWORD.EMPTY;
    } else if (form.password.length < 7) {
      errors.password = Messages.SIGNUP.ERROR.PASSWORD.INVALID;
    } else if (!new RegExp(UpperCase).test(form.password)) {
      errors.password = Messages.SIGNUP.ERROR.PASSWORD.INVALID;
    } else if (!new RegExp(LowerCase).test(form.password)) {
      errors.password = Messages.SIGNUP.ERROR.PASSWORD.INVALID;
    } else if (!new RegExp(Numbers).test(form.password)) {
      errors.password = Messages.SIGNUP.ERROR.PASSWORD.INVALID;
    } else if (/[`~,.<>;':"/[\]|{}()=_+-]/.test(form.password)) {
      errors.password = Messages.SIGNUP.ERROR.PASSWORD.INVALID;
    }

    // if (!form.repeatPassword) {
    //   errors.repeatPassword = Messages.SIGNUP.ERROR.CPASSWORD.EMPTY
    // } else if(form.password !== form.repeatPassword) {
    //   errors.repeatPassword = Messages.SIGNUP.ERROR.CPASSWORD.INVALID
    // }

    return errors;
  },
};

export default Validations;
